import { render, staticRenderFns } from "./ViewOrUpdate.vue?vue&type=template&id=18264d45&scoped=true&"
import script from "./ViewOrUpdate.vue?vue&type=script&lang=js&"
export * from "./ViewOrUpdate.vue?vue&type=script&lang=js&"
import style0 from "./ViewOrUpdate.vue?vue&type=style&index=0&id=18264d45&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18264d45",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gitlab-runner/builds/3ztxUiUz/0/ifirst/dt-survey/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('18264d45')) {
      api.createRecord('18264d45', component.options)
    } else {
      api.reload('18264d45', component.options)
    }
    module.hot.accept("./ViewOrUpdate.vue?vue&type=template&id=18264d45&scoped=true&", function () {
      api.rerender('18264d45', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/form/data/ViewOrUpdate.vue"
export default component.exports